import { render } from "./UnitInput.vue?vue&type=template&id=54930e3e&scoped=true"
import script from "./UnitInput.vue?vue&type=script&lang=js"
export * from "./UnitInput.vue?vue&type=script&lang=js"

import "./UnitInput.vue?vue&type=style&index=0&id=54930e3e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54930e3e"]])

export default __exports__